import { useEffect, useState } from 'react';
import validator from 'validator';
import { Link, useHistory } from 'react-router-dom';

const socialData = [
    {
        id: "1",
        link: "facebook",
        icon: "fab fa-facebook-f"
    },
    {
        id: "2",
        link: "twitter",
        icon: "fab fa-twitter"
    },
    {
        id: "3",
        link: "google-plus",
        icon: "fab fa-google-plus-g"
    }
]

const Signup = () => {

    const history = useHistory();

    const [data, setData] = useState({
        name: '',
        email: '',
        password: '',
        check: ''
    })

    const [msg, setMsg] = useState({
        name: '',
        email: '',
        password: '',
        check: ''
    })

    const [submitCheck, setSubmitCheck] = useState(false)

    useEffect(() => {
        if (localStorage.getItem('encuse')) {
            history.push('/profile')
        }
    }, [])

    const formSubmission = (e) => {
        e.preventDefault()
        setSubmitCheck(true)
        if (!validator.isEmpty(data.name) && validator.isEmail(data.email)
            && !validator.isEmpty(data.password) && (data.check)) {
            console.log(data)
            let formData = new FormData()
            for (const key in data)
                formData.append(key, data[key])
            // props.submit(formData)
            setData({ name: '', email: '', password: '', check: '' })
            setMsg({ name: '', email: '', password: '', check: '' })
            e.target[0].value = ''
            e.target[1].value = ''
            e.target[2].value = ''
            e.target[3].value = ''
        }
        else {
            let name = ''
            let email = ''
            let password = ''
            let check = ''
            if (validator.isEmpty(data.name)) {
                name = 'Name Is Required.'
            }
            if (!validator.isEmail(data.email)) {
                email = 'Email Is Required.'
            }
            if (validator.isEmpty(data.password)) {
                password = 'Password Is Required.'
            }
            if (!(data.check)) {
                check = 'Agree To Privacy Policy Is Required.'
            }
            setMsg({ name, email, password, check })
        }
    }

    return (
        <section className="author-area">
            {
                localStorage.getItem('encuse') ? '' :
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 col-lg-7">
                                {/* Intro */}
                                <div className="intro text-center">
                                    {/* <span>{"Signup"}</span> */}
                                    <h3 className="mt-3 mb-0">{"Create an Account"}</h3>
                                    <p>{"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit."}</p>
                                </div>
                                {/* Item Form */}
                                <form className="item-form card no-hover" onSubmit={(e) => formSubmission(e)}>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group mt-3">
                                                <input type="text" className="form-control" name="name" placeholder="Enter your Name" value={data.name}
                                                    onChange={(e) => {
                                                        setData({ ...data, name: e.target.value });
                                                        if (submitCheck) {
                                                            if (e.target.value) {
                                                                setMsg({ ...msg, name: '' })
                                                            }
                                                            else {
                                                                setMsg({ ...msg, name: 'Name Is Required.' })
                                                            }

                                                        }
                                                    }
                                                    }
                                                />
                                                <label className={`text-danger pl-1 ${msg.name ? `` : `d-none`}`}>{msg.name}</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mt-3">
                                                <input type="email" className="form-control" name="email" placeholder="Enter your Email" value={data.email}
                                                    onChange={(e) => {
                                                        setData({ ...data, email: e.target.value });
                                                        if (submitCheck) {
                                                            if (validator.isEmail(e.target.value)) {
                                                                setMsg({ ...msg, email: '' })
                                                            }
                                                            else {
                                                                setMsg({ ...msg, email: 'Email Is Required.' })
                                                            }
                                                        }
                                                    }
                                                    }
                                                />
                                                <label className={`text-danger pl-1 ${msg.email ? `` : `d-none`}`}>{msg.email}</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mt-3">
                                                <input type="password" className="form-control" name="password" placeholder="Enter your Password" value={data.password}
                                                    onChange={(e) => {
                                                        setData({ ...data, password: e.target.value });
                                                        if (submitCheck) {
                                                            if (e.target.value) {
                                                                setMsg({ ...msg, password: '' })
                                                            }
                                                            else {
                                                                setMsg({ ...msg, password: 'Password Is Required.' })
                                                            }
                                                        }
                                                    }
                                                    }
                                                />
                                                <label className={`text-danger pl-1 ${msg.password ? `` : `d-none`}`}>{msg.password}</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mt-3">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" checked={data.check}
                                                        onChange={(e) => {
                                                            setData({ ...data, check: e.target.checked });
                                                            if (submitCheck) {
                                                                if (e.target.checked) {
                                                                    setMsg({ ...msg, check: '' })
                                                                }
                                                                else {
                                                                    setMsg({ ...msg, check: 'Agree To Privacy Policy Is Required.' })
                                                                }
                                                            }
                                                        }
                                                        }
                                                    />
                                                    <label className="form-check-label" htmlFor="inlineRadio1">I agree to <Link to="/privacy-and-terms">Privacy Policy</Link></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className={`text-danger pl-1 ${msg.check ? `` : `d-none`}`}>{msg.check}</label>
                                        </div>
                                        <div className="col-12">
                                            <button className="btn w-100 mt-3 mt-sm-4" type="submit">Sign Up</button>
                                        </div>
                                        <div className="col-12">
                                            <span className="d-block text-center mt-4">Already have an account? <a href="/login">Login</a></span>
                                        </div>
                                        <div className="col-12">
                                            <hr />
                                            <div className="other-option">
                                                <span className="d-block text-center mb-4">Or</span>
                                                {/* Social Icons */}
                                                <div className="social-icons d-flex justify-content-center">
                                                    {socialData.map((item, idx) => {
                                                        return (
                                                            <a key={`lsd_${idx}`} className={item.link} data-toggle="tooltip" title="Lorem" href>
                                                                <i className={item.icon} />
                                                                <i className={item.icon} />
                                                            </a>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
            }
        </section>
    );
}

export default Signup;